/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import Button from "../../shared/button";
import styles from "./styles.css";
import IconHeart from "../../shared/icon-heart/component";
import WhiteTickIcon from "./images/white-tick.svg";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import InfoIcon from "./images/info_white.svg";
import { getAbExpirementVariant, showNewTestDriveVariant, showTestDriveVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import { getTestDriveCtaText } from "../../../utils/helpers/get-test-drive-cta-text";
import { ORDER_STATUS } from "../../../constants/checkout-constants";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { getTestDriveV2CheckoutURL } from "../../../utils/helpers/get-detail-page-url";
import { testDriveV2Routes } from "../../../constants/au.desktop/test-drive-v2-routes";
import { getFullCarName, getPersonalisedTooltipInfoList, getTooltipInfoList } from "../../../utils/helpers/car-properties";
import Tooltip from "../../shared/tooltip";
import Routes from "../../../constants/routes-constant";
import ArrowIcon from "../../shared/arrow";
import { getCarPrice } from "../../../utils/helpers/calculate-egc-dap";
import { AB_TEST_VARIATIONS, CAR_LIST_EVENT_NAMES, ORDER_TYPE } from "../../../constants/app-constants";
import useUserGeoLocation from "../../../hooks/use-user-geo-location";
import CarDetailNavigationMenuRevamp from "../car-detail-navigation-menu-revamp/component";
import useLoginGate from "../../../hooks/use-login-gate";
const CarDetailStickyViewRevamp = ({
    content,
    ctaProps = {},
    isWishlisted,
    onWishlistClick,
    canFavourite = true,
    userTradeInData,
    tradeInToggleSelected,
    order,
    isUserZeroDpVariant,
    source,
    createOrderConnect,
    personalDetails,
    updateProfileConnect,
    secureToken,
    orderId,
    testDriveConfig,
    menuItems,
    showCta,
    // comingSoon
    isCdpCtaReorderVariant,
    preApprovalOnFlyDesktop,
    startPreApprovalOnFlyConnect,
    comingSoonExperiment,
    getValidQuotesInHouseFinanceConnect,
    updateBasicHubspotConnect,
    getOrderDetailSuccessConnect,
    setTestDriveVariantConnect,
    getInhouseEligibilityConnect,
    getInhousePreApprovalLoanDetailsConnect,
    userEmail
}) => {

    const history = useHistory();

    const {
        appointmentId,
        emiDetails,
        price,
        egc,
        estimatedPrice = 0,
        personalised
    } = content || {};

    const [toolTipTitle, setToolTipTitle] = useState("");
    const [toolTipBody, setToolTipBody] = useState([]);
    const { tradeIn = false } = userTradeInData || {};
    const { testDriveStatus = "" } = order || {};

    const userGeoData = useUserGeoLocation();
    const { state: { name: userState = {} } = {}, country: { isoCode: countryCode } = {} } = userGeoData || {};
    const isTestDriveVariant = showTestDriveVariant({ content, order });
    const { eligibleStateNames = [], enabledForIndia: isTestDriveEnabledForIndia = false } = testDriveConfig?.data || {};
    const isNewTestDriveLocationVariant = showNewTestDriveVariant({ content, order, userState, countryCode, isTestDriveEnabledForIndia, eligibleStateNames, comingSoonExperiment });
    const testDriveDisabled = ctaProps?.key === "comingSoon" ? false : ctaProps?.disabled;
    const carName = getFullCarName(content);
    const { emiPerWeek } = emiDetails || {};

    const handleGetPreApprovalClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isPreApprovalOnFlyVariant = getAbExpirementVariant(
            preApprovalOnFlyDesktop,
            EXPERIMENT_TYPE.VARIANT_B
        );
        if (isPreApprovalOnFlyVariant && startPreApprovalOnFlyConnect) {
            startPreApprovalOnFlyConnect({ entryPoint: "cdp-sticky-header", ctaText: "Continue Booking", refetchOnClose: true });
        } else {
            history.push(Routes.get_pre_approval);
        }
    };
    const BottomLink = () => {
        return (
            <div
                styleName={"styles.financeBottomLink"}>
                <span>Want to know your exact finance rates?</span>
                <Button text="GET PRE-APPROVAL" leftImage={WhiteTickIcon} onClick={handleGetPreApprovalClick} btnView="new" />
                <small>No impact on your credit score</small>
            </div>
        );
    };
    useEffect(() => {
        if (personalised) {
            setToolTipTitle(`Weekly payment of ${makePriceLabelRound(emiPerWeek)}`);
            setToolTipBody(getPersonalisedTooltipInfoList(emiDetails));
        } else {
            setToolTipTitle(`Weekly payment of ${makePriceLabelRound(emiPerWeek)}`);
            setToolTipBody(getTooltipInfoList(emiDetails, isUserZeroDpVariant).concat(<BottomLink />));
        }
    }, [emiPerWeek, emiDetails, personalised, isUserZeroDpVariant]);
    const displayIcon = () => {
        if (!ctaProps.iconType) {
            return (null);
        } else if (ctaProps.iconType === "Info") {
            return (
                <div
                    styleName={"styles.infoicon"}>
                    {<div styleName={"styles.hovertext"}>
                        <img src={InfoIcon} alt={InfoIcon} />
                        <div styleName={"styles.paratext styles.top_arrow"}>
                            <p>You can choose to be notified if this car becomes available to purchase in the near future</p>
                        </div>
                    </div>}
                </div>);
        } else {
            return (<div styleName={"styles.iconHeart"}>
                {canFavourite &&
                    <IconHeart
                        active={isWishlisted}
                        onClick={onWishlistClick}
                        source="cdp_revamp"
                        customStyle={["outer-revamp"]}
                    />
                }
            </div>);
        }
    };
    const proceedWithTestDriveRef = useRef(null);
    const testDriveGate = useLoginGate({
        requiredFields: ["profileName", "email", "mobile"],
        persistKey: "logingate_test_drive",
        onComplete: () => proceedWithTestDriveRef.current()
    });
    const getProfilePayload = () => {
        const { firstName, lastName } = personalDetails || {};
        return {
            ...personalDetails,
            firstName: firstName ? firstName.trim() : "",
            lastName: lastName ? lastName.trim() : ""
        };
    };
    const updateProfile = async (payload) => {
        try {
            await updateProfileConnect(payload, secureToken);
        } catch (error) {
            throw error;
        }
    };
    const proceedWithTestDrive = async () => {
        let redirectUrl = "";
        if (testDriveStatus === ORDER_STATUS.BOOKED) {
            const { relativeURL: bookingConfirmationRoute } = getTestDriveV2CheckoutURL(content, testDriveV2Routes.bookingConfirmed.route);
            redirectUrl = bookingConfirmationRoute;
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TEST_DRIVE_V2_CTA_SELECTED, {
                eventLabel: "track_booking",
                eventAction: "cta_selected"
            });
        } else {
            //* Should be fired before "purchase started" event inside createOrderConnect(orderPayload) below
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TEST_DRIVE_V2_CTA_SELECTED, {
                eventLabel: "test_drive",
                eventAction: "cta_selected"
            });
            const orderPayload = {
                vehiclePrice: getCarPrice({ egcPrice: content.egc, dapPrice: content.price }).egc.value,
                appointmentId,
                orderType: ORDER_TYPE.PRODUCT_TEST_DRIVE,
                tdUserType: AB_TEST_VARIATIONS.TEST,
                deliveryAddress: { customerPhoneNumber: personalDetails.phone },
                pickUpAddress: { customerPhoneNumber: personalDetails.phone },
                source: "WebApp"
            };
            const profilePayload = getProfilePayload();
            try {
                let orderResponse;
                if (orderId) {
                    await updateProfile(profilePayload);
                } else {
                    orderResponse = await createOrderConnect(orderPayload);
                    getOrderDetailSuccessConnect(orderResponse);
                }
                await Promise.allSettled([
                    getValidQuotesInHouseFinanceConnect(CAR_LIST_EVENT_NAMES.TEST_DRIVE_FINANCE),
                    getInhousePreApprovalLoanDetailsConnect()
                ]);
                await getInhouseEligibilityConnect();
                if (!orderId) {
                    await updateProfile(profilePayload);
                    updateBasicHubspotConnect(orderResponse?.orderId, { ...orderResponse, source: "WebApp" });
                    setTestDriveVariantConnect({ email: userEmail || personalDetails.userEmail, testDriveVariant: true });
                }
            } catch (error) {
                // proceed to finance even if some calls fail
            }
            const { relativeURL: financeRoute } = getTestDriveV2CheckoutURL(content, testDriveV2Routes.financeDetails.route);
            redirectUrl = financeRoute;
        }
        history.push(redirectUrl);
    };

    proceedWithTestDriveRef.current = proceedWithTestDrive;

    const onClickTestDriveV2 = () => {
        testDriveGate.trigger();
    };
    const handleBackClick = () => {
        history.goBack();
    };
    const onClickFinanceInfo = () => {
    };

    const fromGallery = source === "gallery";
    const topWrapper = fromGallery ? "styles.galleryWrapper" : "styles.wrapper";
    return (
        <div styleName={topWrapper}>
            <div className={"container"}>
                <div className={"row"} styleName="styles.headerRow">
                    {
                        !fromGallery && (
                            <div>
                                <CarDetailNavigationMenuRevamp menuItems={menuItems} />
                            </div>
                        )
                    }
                    {showCta && <div styleName={`styles.priceCtaWrapper ${fromGallery ? "styles.priceCtaWrapperGallery" : ""}`}>
                        <div styleName="styles.headerColumn">
                            {source === "gallery" && <span onClick={handleBackClick} styleName="styles.backArrow" ><ArrowIcon rotateBy={180} /></span>}
                            <div styleName={"styles.carName"}>
                                <h2 styleName={fromGallery ? "styles.white styles.carFullName" : "styles.carFullName"}>{carName}<span /></h2>
                                <div styleName="styles.carPriceWrapper">

                                    <div styleName={fromGallery ? "styles.white styles.price" : "styles.price"}>
                                        <h3 styleName={fromGallery ? "styles.white styles.priceAmount" : "styles.priceAmount"}>{(tradeIn && tradeInToggleSelected) ? makePriceLabelRound(estimatedPrice) : makePriceLabelRound(egc || price)}</h3>
                                    </div>
                                    <div styleName={fromGallery ? "styles.white styles.emiPrice" : "styles.emiPrice"}>
                                        <h3 styleName={fromGallery ? "styles.white styles.emiPriceAmount" : "styles.emiPriceAmount"}>{makePriceLabelRound(emiPerWeek)}/week</h3>
                                        <div styleName="styles.financeInfoTooltip">
                                            <Tooltip showOnHover={true} customStyleHeading={true} heading={toolTipTitle} body={toolTipBody} onClickCallback={onClickFinanceInfo}>
                                                <img styleName="styles.financeInfoTooltipIcon" height={13} width={13} src={InfoIcon} alt="Weekly Payment" />
                                            </Tooltip>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div styleName={"styles.carButtonWrapper"}>
                            {displayIcon()}
                            <div styleName={"styles.ctaWrapper"}>
                                {ctaProps.transparentButton ?
                                    <div styleName="styles.transparentBtnWrapper">
                                        <Button
                                            transparent
                                            text={ctaProps.text}
                                            disabled={ctaProps.disabled}
                                            onClick={(e) => ctaProps.action(AU_DESKTOP_EVENTS.CAR_DETAILS_ATF_INTERACTIONS, e)}
                                            customStyle={["cdpSticky"]}
                                        />
                                    </div> :
                                    <React.Fragment>
                                        {isCdpCtaReorderVariant ? (<>
                                            <div styleName="styles.transparentBtnWrapper">
                                                <Button
                                                    variant={"secondary"}
                                                    text={ctaProps.text}
                                                    disabled={ctaProps.disabled}
                                                    onClick={(e) => ctaProps.action(AU_DESKTOP_EVENTS.CAR_DETAILS_ATF_INTERACTIONS, e)} />
                                            </div>
                                            {(isNewTestDriveLocationVariant && !isTestDriveVariant) &&
                                            <div styleName="styles.btnWrapper">
                                                <Button
                                                    text={getTestDriveCtaText(ORDER_STATUS[testDriveStatus])}
                                                    disabled={testDriveDisabled}
                                                    isLoading={ctaProps.isLoading}
                                                    onClick={onClickTestDriveV2}
                                                />
                                            </div>}

                                        </>) : (
                                            <>
                                                {(isNewTestDriveLocationVariant && !isTestDriveVariant) &&
                                            <div styleName="styles.transparentBtnWrapper">
                                                <Button
                                                    variant={"secondary"}
                                                    text={getTestDriveCtaText(ORDER_STATUS[testDriveStatus])}
                                                    disabled={testDriveDisabled}
                                                    isLoading={ctaProps.isLoading}
                                                    onClick={onClickTestDriveV2}
                                                />
                                            </div>}
                                                <div styleName="styles.btnWrapper">
                                                    <Button
                                                        text={ctaProps.text}
                                                        disabled={ctaProps.disabled}
                                                        onClick={(e) => ctaProps.action(AU_DESKTOP_EVENTS.CAR_DETAILS_ATF_INTERACTIONS, e)} />
                                                </div>
                                            </>)}

                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    );
};

CarDetailStickyViewRevamp.propTypes = {
    content: PropTypes.object,
    ctaProps: PropTypes.object,
    onWishlistClick: PropTypes.func,
    onClickNotifyIcon: PropTypes.func,
    isWishlisted: PropTypes.bool,
    canFavourite: PropTypes.bool,
    comingSoon: PropTypes.bool,
    userTradeInData: PropTypes.object,
    tradeInToggleSelected: PropTypes.bool,
    order: PropTypes.object,
    isUserZeroDpVariant: PropTypes.bool,
    source: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    createOrderConnect: PropTypes.func,
    personalDetails: PropTypes.object,
    updateProfileConnect: PropTypes.func,
    secureToken: PropTypes.string,
    orderId: PropTypes.string,
    testDriveConfig: PropTypes.object,
    isDesktopCtaOptimizationVariant: PropTypes.bool,
    menuItems: PropTypes.array,
    showCta: PropTypes.bool,
    isCdpCtaReorderVariant: PropTypes.bool,
    preApprovalOnFlyDesktop: PropTypes.object,
    startPreApprovalOnFlyConnect: PropTypes.func,
    comingSoonExperiment: PropTypes.object,
    getValidQuotesInHouseFinanceConnect: PropTypes.func,
    updateBasicHubspotConnect: PropTypes.func,
    getOrderDetailSuccessConnect: PropTypes.func,
    setTestDriveVariantConnect: PropTypes.func,
    getInhouseEligibilityConnect: PropTypes.func,
    getInhousePreApprovalLoanDetailsConnect: PropTypes.func,
    userEmail: PropTypes.string
};

export default CarDetailStickyViewRevamp;
